import { TEventsKeys } from '@core';
import { EEVents } from '@core/constants';

const EXTRACT_EVENT_NAMESPACE = (event: TEventsKeys): EEVents =>
  (event.split('/')[1] as EEVents) || ('' as EEVents);

const BUILD_EVENT = (
  event: EEVents,
  namespace?: string,
  key?: string,
): EEVents => {
  if (!namespace) return event;

  return (event + '/' + namespace + (key ? '/' + key : '')) as EEVents;
};

const ALL_NAMESPACE_EVENTS = (event: TEventsKeys) =>
  new RegExp(`^(${event}).*$`, 'g') as unknown as EEVents;

const EXTRACT_CORE_NAMESPACE = (event: TEventsKeys): EEVents =>
  Array.isArray(event.split('/'))
    ? (event.split('/')[0] as EEVents)
    : (event as EEVents);

export {
  ALL_NAMESPACE_EVENTS,
  BUILD_EVENT,
  EXTRACT_EVENT_NAMESPACE,
  EXTRACT_CORE_NAMESPACE,
};
